import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    pxArrayToRem,
    labelClassName,
    videoPlayerClassName,
    captionClassName,
} from '@archipro-design/aria';

export const VideoGrid: StyleRule = ({ theme }) => ({
    gap: pxToRem(60),

    [theme.screen.laptop]: {
        gridGap: `${pxToRem(76)} 0`,
    },
});

interface ImageDimension {
    width: number;
    height: number;
}

export const VideoPlaceholder: (imageDimensions: ImageDimension) => StyleRule =
    (imageDimensions) => () => {
        return {
            position: 'relative',
            width: '100%',
            height: pxToRem(imageDimensions.height),
        };
    };

export const VideoTile: StyleRule = ({ theme }) => ({
    position: `relative`,
    gridGap: pxToRem(8),

    [`& .${labelClassName}`]: {
        color: theme.siteVariables.colorScheme.default?.foreground,
    },

    [`& .${captionClassName}`]: {
        lineHeight: 1.5,
        padding: pxArrayToRem([16, 18, 0, 18]),
        fontSize: pxToRem(12),
    },

    [`& .${videoPlayerClassName}`]: {
        overflow: 'hidden',
        width: '100%',
    },

    [theme.screen.laptop]: {
        gridGap: pxToRem(30),
        padding: pxToRem(14),
        paddingBottom: 0,

        [`& .${captionClassName}`]: {
            padding: 'unset',
            fontSize: 'unset',
        },
    },
});
